/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { Button, Popup, Pane } from '@leverege/ui-elements'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import StringUtil from '@leverege/string-util'
import { ViewerFactory } from '~/viewers'
import SimAttributeEditor from './SimAttributeEditor'
import SimUpdaterEditor from './SimUpdaterEditor'

import style from './style.css'

function EditorPopover( {
  title,
  cxt,
  fname,
  value,
  simulated,
  attribute,
  onSetUpdater,
  onSetValue,
  onShowFullEditor,
  onClose,
  device
} ) {
  const onUpdate = useCallback( ( evt ) => {
    onSetValue( evt )
    onClose()
  }, [ onSetValue, onClose ] )
  return (
    <Pane variant="attributeEditor">
      <Pane variant="attributeEditorHeader">{title}</Pane>
      <Pane variant="attributeEditorBody">
        <SimAttributeEditor
          device={device}
          cxt={cxt}
          name={fname}
          value={value}
          simulated={simulated}
          attribute={attribute} 
          onSetUpdater={onSetUpdater} 
          onSetValue={onUpdate}
          onShowFullEditor={onShowFullEditor} />
      </Pane>
    </Pane>
  )
}

export default class SimAttributeView extends React.Component {
  
  static propTypes = {
    updaters : PropTypes.object,
    attribute : PropTypes.object,
    value : PropTypes.any,
    name : PropTypes.any,
    device : PropTypes.object,
    simulated : PropTypes.bool,
    onSetUpdater : PropTypes.func,
    eventData : PropTypes.any
  }

  constructor( props ) {
    super( props )
    this.state = { showFullEditor : false }
  }

  onSetUpdater = ( evt ) => {
    this.overlay && this.overlay.hide()
    this.props.onSetUpdater( evt )
    if ( this.state.showFullEditor ) {
      this.setState( { showFullEditor : false } )
    }
  }

  onSetValue = ( evt ) => {
    if ( this.props.eventData !== undefined ) {
      evt.data = this.props.eventData
    }
    this.overlay && this.overlay.hide()
    this.props.onSetValue( evt )
    if ( this.state.showFullEditor ) {
      this.setState( { showFullEditor : false } )
    }
  }

  // eslint-disable-next-line react/no-unused-class-component-methods
  setOverlay = ( ref ) => {
    this.overlay = ref
  }

  onShowFullEditor = ( attribute ) => {
    this.overlay && this.overlay.hide()
    this.setState( { showFullEditor : true } )
  }

  onHideFullEditor = ( ) => {
    this.setState( { showFullEditor : false } )
  }

  render() {
    const { attribute, value, name, device, simulated, updaters, cxt, showDelete, onDelete } = this.props
    const { showFullEditor } = this.state
    const cfg = { key : `simview-${attribute.id}`, cxt, showDelete, value, name, editable : simulated, onSetValue : this.onSetValue }
    let viewer = ViewerFactory.createViewer( attribute, device, cfg )

    // console.log( attribute, cxt )
    if ( viewer ) {

      // if ( !simulated ) {
      //   return <div>{viewer}</div>
      // }

      const fname = StringUtil.capitalizeAll( name || attribute.name )
      const title = fname.toUpperCase()
      const cUpdater = updaters && updaters[attribute.path] && updaters[attribute.path].updater
      
      if (
        attribute.type !== 'relationship' &&
        !( attribute.type === 'parentRelationship' && !attribute.relationshipType?.startsWith( 'oneTo' ) ) &&
        attribute.type !== 'geoJson' && 
        attribute.type !== 'shape'
      ) {
        viewer = (
          <Popup
            attachment="bottom center"
            targetAttachment="top center"
            render={( onClose ) => {
              return (
                <EditorPopover cxt={cxt}
                  title={fname}
                  name={fname}
                  value={value}
                  simulated={simulated}
                  attribute={attribute}
                  device={device}
                  onSetUpdater={this.onSetUpdater} 
                  onSetValue={this.onSetValue}
                  onShowFullEditor={this.onShowFullEditor}
                  onClose={onClose} />
              )
            }}
            title={(
              <div>
                {viewer}
              </div>
            )} />
        )
      }

      return (
        <div className={attribute.type === 'relationship' || attribute.type === 'parentRelationship' ? style.fullWidth : ''}>
          { showDelete ? <Button title="delete data item" variant="deleteLink|link" className={style.delete} icon="fa fa-times" onClick={onDelete} /> : null }
          {viewer}
          <SimUpdaterEditor
            show={showFullEditor}
            onHideFullEditor={this.onHideFullEditor}
            title={title}
            name={name} 
            updater={cUpdater} 
            attribute={attribute}
            device={device}
            onSetUpdater={this.onSetUpdater} />
        </div>
      )
    } 
    return null
    
  }
}
